var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: { items: _vm.applyToTotalItems },
                    model: {
                      value: _vm.setting.ApplyToTotal,
                      callback: function ($$v) {
                        _vm.$set(_vm.setting, "ApplyToTotal", $$v)
                      },
                      expression: "setting.ApplyToTotal",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("text-if-value-text"), fancy: "" },
                    model: {
                      value: _vm.setting.Text,
                      callback: function ($$v) {
                        _vm.$set(_vm.setting, "Text", $$v)
                      },
                      expression: "setting.Text",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      disabled: _vm.setting.NummericValueTemplate === null,
                      label: _vm.$ct("text-if-value-nummeric-value"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.setting.NummericValueTemplate,
                      callback: function ($$v) {
                        _vm.$set(_vm.setting, "NummericValueTemplate", $$v)
                      },
                      expression: "setting.NummericValueTemplate",
                    },
                  }),
                  _c(
                    "w-link",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.toggleNummericValue()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.toggleNummericValueText))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("app-conditions-edit", {
            attrs: { conditions: _vm.setting.Conditions, fields: _vm.fields },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }